/**
 * Restart Test Conversation
 *
 * Drops the test session and reloads, keeping test mode and the profile under
 * test. The next boot has no session to resume, so the first send starts a
 * fresh one.
 */

import { resetConversation } from '@/actions/session/resetConversation';
import type { ActionEnvironment } from '@/domain/actionEnvironment';
import { reloadPage } from '@/lib/reloadPage';

export async function restartTestConversation(env: ActionEnvironment): Promise<void> {
  env.logAction('testMode/restartTestConversation');

  // Through the gateway, like the other two doors. `logout()`'s epoch bump is
  // the only thing that neutralises an in-flight session create, and dropping
  // the session id alone does not move it: `reloadPage()` does not halt this
  // document, so a create that resolves afterwards passes the epoch check and
  // writes its id straight back — `testSessionStarted` guards on `active`,
  // which restart deliberately keeps true. The persist write is synchronous, so
  // it lands before unload and the next boot resumes the session the author
  // asked to drop.
  await resetConversation(env);

  // Kept although `resetConversationLocally` now ends the test session itself:
  // clearing the id is this action's own guarantee, not one that moves with
  // whichever teardown path the reset happens to take.
  env.store.testModeMutations.testSessionEnded();
  reloadPage();
}
